import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=4dd6c4fe&scoped=true&"
import script from "./PromoBanner.vue?vue&type=script&lang=js&"
export * from "./PromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromoBanner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PromoBanner.vue?vue&type=style&index=1&id=4dd6c4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6c4fe",
  null
  
)

export default component.exports